// extracted by mini-css-extract-plugin
export default {"gauge":"gauge-hfZcn","gauge__bar":"gauge__bar-aAOgu","gauge__bar-level":"gauge__bar-level-Q6fRZ"};